import React, { Component } from "react";
import "./app_bottom_bar.css";
import AppMainButton from "../app_main_button/app_main_button";
import AppTransparentButton from "../app_transparent_button/app_transparent_button";
import AppSubButton from "../app_sub_button/app_sub_button";

class AppBottomBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  propType() {
    return this.props.type;
  }
  propAlignContent() {
    return this.props.alignContent;
  }
  propButtonWidth() {
    return this.props.buttonWidth;
  }

  propEnable() {
    return this.props.enable;
  }

  getTypeBottomNavigation() {
    if (this.propType() == "client") {
      return (
        <div
          className="fixed-bottom app_bottom_mobile_container"
          style={{
            justifyContent:
              this.propAlignContent() == "right" ? "flex-end" : "",
          }}
        >
          {this.props.lableDiscard && (
            <AppTransparentButton
              label={this.props.lableDiscard}
              enable={this.props.enable}
              onClick={(e) => {
                this.props.onDiscard(e);
              }}
              borderedLess={false}
              icon={!this.props.mainButtonIcon ? false : true}
              buttonWidth={this.propButtonWidth() || "171px"}
            />
          )}
          {this.props.lableNext && (
            <AppMainButton
              label={this.props.lableNext}
              enable={this.props.enable}
              onClick={(e) => {
                if (this.propEnable() == true) {
                  this.props.onNext(e);
                }
              }}
              icon={!this.props.mainButtonIcon ? false : true}
              buttonWidth={this.propButtonWidth() || "171px"}
            />
          )}
        </div>
      );
    } else {
      return (
        <div className="fixed-bottom app_bottom_container">
          <div className="left-bottom">
            <AppTransparentButton
              label={this.props.lableDiscard}
              enable={this.props.enable}
              onClick={(e) => {
                this.props.onDiscard(e);
              }}
              borderedLess={true}
            />
          </div>
          <div className="right-bottom">
            <AppSubButton
              label={this.props.lableSaveAndClose}
              onClick={(e) => {
                this.props.onSaveAndClose(e);
              }}
            />
            {this.props.lableNext ?
              <AppMainButton
                label={this.props.lableNext}
                enable={this.props.enable}
                onClick={(e) => {
                  if (this.propEnable() == true) {
                    this.props.onNext(e);
                  }
                }}
                icon={true}
              /> : null
            }
          </div>
        </div>
      );
    }
  }

  render() {
    return <div>{this.getTypeBottomNavigation()}</div>;
  }
}

export default AppBottomBar;
